import { render, staticRenderFns } from "./BookingExtraData.vue?vue&type=template&id=72de5ce5&scoped=true"
import script from "./BookingExtraData.vue?vue&type=script&lang=js"
export * from "./BookingExtraData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de5ce5",
  null
  
)

export default component.exports